import e from "react";
import t from "react-dom";
import { componentName as o } from "../../../utils/bem/index.js";
import { PopoverArrow as r } from "./Arrow.js";
import { Content as n } from "./Content.js";
import { optimalConfig as i } from "./helpers.js";
function p(e) {
  if (void 0 === e) throw ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function s(e, t) {
  if (!(e instanceof t)) throw TypeError("Cannot call a class as a function");
}
function c(e, t) {
  for (var o = 0; o < t.length; o++) {
    var r = t[o];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function a(e, t, o) {
  return t && c(e.prototype, t), o && c(e, o), e;
}
function u(e, t, o) {
  return t in e ? Object.defineProperty(e, t, {
    value: o,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = o, e;
}
function l(e) {
  return (l = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}
function f(e, t) {
  if ("function" != typeof t && null !== t) throw TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), t && y(e, t);
}
function h(e) {
  for (var t = 1; t < arguments.length; t++) {
    var o = null != arguments[t] ? arguments[t] : {},
      r = Object.keys(o);
    "function" == typeof Object.getOwnPropertySymbols && (r = r.concat(Object.getOwnPropertySymbols(o).filter(function (e) {
      return Object.getOwnPropertyDescriptor(o, e).enumerable;
    }))), r.forEach(function (t) {
      u(e, t, o[t]);
    });
  }
  return e;
}
function d(e, t) {
  return t = null != t ? t : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : function (e, t) {
    var o = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      o.push.apply(o, r);
    }
    return o;
  }(Object(t)).forEach(function (o) {
    Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(t, o));
  }), e;
}
function y(e, t) {
  return (y = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}
function v(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct || Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var o,
      r,
      n = l(e);
    if (t) {
      var i = l(this).constructor;
      r = Reflect.construct(n, arguments, i);
    } else r = n.apply(this, arguments);
    return (o = r) && ("object" == (o && "undefined" != typeof Symbol && o.constructor === Symbol ? "symbol" : typeof o) || "function" == typeof o) ? o : p(this);
  };
}
var m = function (t) {
  f(c, t);
  var i = v(c);
  function c() {
    var e;
    return s(this, c), e = i.apply(this, arguments), u(p(e), "state", {
      style: {
        left: 0,
        top: 0
      }
    }), u(p(e), "position", function () {
      if (e.props.open && e.refs.container) {
        var t = {
            top: 0,
            left: 0
          },
          o = Math.sqrt(e.props.arrowSize * e.props.arrowSize * 2);
        switch (e.props.arrowDirection) {
          case "up":
            t.top = e.props.spaceToTarget;
            break;
          case "down":
            t.top = -e.props.spaceToTarget;
            break;
          case "left":
            t.left = e.props.spaceToTarget;
            break;
          case "right":
            t.left = -e.props.spaceToTarget;
        }
        (e.state.style.top !== t.top || e.state.style.left !== t.left) && e.setState({
          hypotenuse: o,
          style: t
        });
      }
    }), e;
  }
  return a(c, [{
    key: "componentDidMount",
    value: function value() {
      this.position();
    }
  }, {
    key: "componentDidUpdate",
    value: function value() {
      this.position();
    }
  }, {
    key: "render",
    value: function value() {
      if (!this.props.open) return null;
      var t = o("popover qa-popover", this.props.className, "point-to-" + this.props.pointTo, "arrow-direction-" + this.props.arrowDirection, "arrow-position-" + this.props.arrowPosition, this.props.open && "open");
      return e.createElement("div", {
        className: t,
        ref: "container",
        onClick: this.props.onClick,
        style: this.state.style
      }, e.createElement(r, d(h({}, this.props), {
        hypotenuse: this.state.hypotenuse,
        size: this.props.arrowSize,
        direction: this.props.arrowDirection,
        alignment: this.props.pointTo
      })), e.createElement(n, this.props));
    }
  }]), c;
}(e.Component);
u(m, "displayName", "PopoverInner"), u(m, "defaultProps", {
  arrowDirection: "up",
  pointTo: "center",
  arrowOffset: 0,
  arrowPosition: "center",
  arrowSize: 8,
  spaceToTarget: 0,
  edgeOffset: 10,
  borderWidth: 1
});
var b = function (o) {
  f(n, o);
  var r = v(n);
  function n(o) {
    var c;
    return s(this, n), u(p(c = r.call(this, o)), "popoverContainerRef", e.createRef()), u(p(c), "state", {}), u(p(c), "removeOnClickListener", function () {
      document.removeEventListener("click", c.handleHidePopoverContent);
    }), u(p(c), "handleHidePopoverContent", function (e) {
      var o, r;
      t.findDOMNode(c.popoverContainerRef.current).contains(e.target) || (null === (o = (r = c.props).onHide) || void 0 === o || o.call(r), c.removeOnClickListener());
    }), u(p(c), "_optimalPositioning", function () {
      var e = c.props.containTo;
      if (e && c.props.open) {
        var o = t.findDOMNode(p(c)),
          r = i(("function" == typeof e ? e() : e).getBoundingClientRect(), o.parentNode.getBoundingClientRect(), o.querySelector(".popover-content").getBoundingClientRect(), c.state.arrowDirection || c.props.arrowDirection, c.state.arrowPosition || c.props.arrowPosition);
        r && (r.arrowDirection !== (c.state.arrowDirection || c.props.arrowDirection) || r.arrowPosition !== (c.state.arrowPosition || c.props.arrowPosition)) && c.setState(r);
      }
    }), c.handleHidePopoverContent = c.handleHidePopoverContent.bind(p(c)), c;
  }
  return a(n, [{
    key: "componentDidMount",
    value: function value() {
      this._optimalPositioning(), this.props.open && document.addEventListener("click", this.handleHidePopoverContent);
    }
  }, {
    key: "componentDidUpdate",
    value: function value(e) {
      this._optimalPositioning(), !e.open && this.props.open && this.props.onHide ? document.addEventListener("click", this.handleHidePopoverContent) : e.open && !this.props.open && this.props.onHide && document.removeEventListener("click", this.handleHidePopoverContent);
    }
  }, {
    key: "componentWillUnmount",
    value: function value() {
      this.removeOnClickListener();
    }
  }, {
    key: "render",
    value: function value() {
      return e.createElement(m, d(h({}, this.props), {
        ref: this.popoverContainerRef,
        arrowDirection: this.state.arrowDirection || this.props.arrowDirection,
        arrowPosition: this.state.arrowPosition || this.props.arrowPosition
      }));
    }
  }]), n;
}(e.Component);
u(b, "displayName", "Popover");
export { b as Popover };